import type { TabsDesignTokens, TabsTokenSections } from '@openng/optimus-ui-themes/types/tabs';

export const tablist: TabsTokenSections.Tablist = {
	borderWidth: '0 0 2px 0',
	background: 'transparent',
	borderColor: '{surface.100}',
};

export const tab: TabsTokenSections.Tab = {
	borderWidth: '0 0 2px 0',
	borderColor: '{surface.100}',
	activeBorderColor: '{primary.300}',
	activeColor: '{surface.950}',
};

export default {
	tablist,
	tab,
} satisfies TabsDesignTokens;
